export const CrearSDS = 'CrearSDS';
export const VisualizarSDS = 'VisualizarSDS';
export const VerDetalleSDSInterno = 'VerDetalleSDSInterno';
export const EditarSDS = 'EditarSDS';
export const ReprogramarSDS = 'ReprogramarSDS';
export const CancelarSDS = 'CancelarSDS';
export const ReasignarDesasignarSDS = 'ReasignarDesasignarSDS';
export const AdjuntarArchivoSDS = 'AdjuntarArchivoSDS';
export const VisualizarPT = 'VisualizarPT';
export const FinalizarSDS = 'FinalizarSDS';
export const EliminarBorradorSDS = 'EliminarBorradorSDS';
export const BandejaInspeccion = 'BandejaInspeccion';
